import { Injectable, inject } from '@angular/core';
import { HttpClient, HttpHeaders, HttpParams } from '@angular/common/http';
import { environment } from '../../environments/environment';

import { CardSubCategory } from '../used-equipments/models/cardSubcategory.model';
import { SubCategoryInfo } from '../used-equipments/models/subcategory.model';
import { Category } from '../used-equipments/models/category.model';
import { ListSubcategory } from '../used-equipments/models/subcategoryList.model';
import { EquipmentListSubcategory } from '../used-equipments/models/equipmentList.model';

@Injectable({
  providedIn: 'root',
})
export class SecondHandService {
  private readonly http = inject(HttpClient);
  private readonly apiUrl = environment.apiURL;

  private readonly options = {
    headers: new HttpHeaders({ 'Content-Type': 'application/json' }),
    params: new HttpParams(),
  };

  savePopUp(data: unknown) {
    return this.http.post(`${this.apiUrl}sales/`, data, this.options);
  }

  getCategoriesHome() {
    return this.http.get<any[]>(`${this.apiUrl}used-sub-categories/`, {
      ...this.options,
      params: this.options.params.set('most_wanted', 'true'),
    });
  }

  getCategories() {
    return this.http.get<Category[]>(`${this.apiUrl}used-equipment-categories/`, this.options);
  }

  getSubcategoriesCards(slug: string) {
    return this.http.get<CardSubCategory[]>(`${this.apiUrl}used-sub-categories/`, {
      ...this.options,
      params: this.options.params.set('category__slug', slug),
    });
  }

  getSubcategoryInfo(slug: string) {
    return this.http.get<SubCategoryInfo>(
      `${this.apiUrl}used-equipment-category-by-slug/${slug}`,
      this.options
    );
  }

  getSubcategoryList(slug: string) {
    return this.http.get<ListSubcategory>(
      `${this.apiUrl}used-sub-category-by-slug/${slug}`,
      this.options
    );
  }

  getSubcategoryEquipmentList(slug: string, filters: string) {
    return this.http.get<EquipmentListSubcategory[]>(
      `${this.apiUrl}used-equipment/?sub_category__slug=${slug}${filters}`,
      this.options
    );
  }
}
